module.exports = __webpack_public_path__ + "img/program-ending.b16c8872.jpg";